import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { googleCalendarApi } from '../lib/api/googleCalendar'
import type { GoogleCalendarConnectionStatus } from '../lib/api'

export const googleCalendarConnectionKey = ['google-calendar-connection'] as const

export function useGoogleCalendarConnection() {
  return useQuery({
    queryKey: googleCalendarConnectionKey,
    queryFn: googleCalendarApi.status,
  })
}

export function useConnectGoogleCalendar() {
  return useMutation({
    mutationFn: googleCalendarApi.connect,
    onSuccess: (result) => {
      window.location.assign(result.url)
    },
  })
}

export function useDisconnectGoogleCalendar() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: googleCalendarApi.disconnect,
    onSuccess: (status: GoogleCalendarConnectionStatus) => {
      queryClient.setQueryData(googleCalendarConnectionKey, status)
    },
  })
}
